import '../scss/frontend.scss';
import { isInViewport } from './parts/helpers';
import { setFooterMenuActive, changeExpirationDateForReject, setRealViewportHeight, playVideo, validateFirstName, validateLastName } from './components/helpers';
import Popup from './parts/popup-window';
function validateCF7() {
    const firstNameField = document.querySelector('input[name="first-name"]');
    const lastNameField = document.querySelector('input[name="last-name"]');
    if (firstNameField) {
        firstNameField.addEventListener('blur', () => {
            if (var_from_php.invalid_letters_text) {
                validateFirstName(firstNameField, var_from_php.invalid_letters_text, 2);
            }
            else {
                validateFirstName(firstNameField, "Type more than 2 characters, just letters", 2);
            }
        });
    }
    if (lastNameField) {
        lastNameField.addEventListener('blur', () => {
            if (var_from_php.invalid_letters_text) {
                validateLastName(lastNameField, var_from_php.invalid_letters_text, 2);
            }
            else {
                validateLastName(lastNameField, "Type more than 2 characters, just letters", 2);
            }
        });
    }
}
function ready() {
    const popupInstance = new Popup();
    const header = document.querySelector('.site-header');
    const mobileOpenBtn = document.querySelector('.mobile-open-btn');
    const mobileMenuLinks = document.querySelectorAll('#header-content .menu-item a');
    const siteHeaderCTA = document.querySelector('.site-header__cta');
    const AnimateTitles = document.querySelectorAll('.js-animate-title');
    const AnimateWords = document.querySelectorAll('.js-animate-word');
    const AnimateFadeInElems = document.querySelectorAll('.js-animate-fadeIn');
    const blockInfo = document.querySelector('.block-info__numbers');
    const tabbingFullWidth = document.querySelectorAll('.block-tabbing--theme-full_width');
    function checkInView() {
        [...AnimateTitles].forEach((item) => {
            if (isInViewport(item)) {
                item.classList.add('animated__wordWrap');
            }
            else {
                item.classList.remove('animated__wordWrap');
            }
        });
        [...AnimateWords].forEach((item) => {
            if (isInViewport(item)) {
                item.classList.add('animated__wordWrap');
            }
            else {
                item.classList.remove('animated__wordWrap');
            }
        });
        [...AnimateFadeInElems].forEach((item) => {
            if (isInViewport(item)) {
                item.classList.add('animated__fadeIn');
            }
            else {
                item.classList.remove('animated__fadeIn');
            }
        });
        [...tabbingFullWidth].forEach((item) => {
            const media = item.querySelectorAll('.js-animate-image');
            media.forEach(imgWrapper => {
                var _a, _b;
                const src = imgWrapper.getAttribute('data-src');
                if (isInViewport(item)) {
                    if (!((_a = imgWrapper.querySelector('img')) === null || _a === void 0 ? void 0 : _a.getAttribute('src'))) {
                        (_b = imgWrapper.querySelector('img')) === null || _b === void 0 ? void 0 : _b.setAttribute('src', src);
                    }
                }
            });
        });
    }
    popupInstance.init();
    setFooterMenuActive();
    changeExpirationDateForReject();
    setRealViewportHeight();
    validateCF7();
    playVideo();
    function openMobileMenu() {
        var _a;
        (_a = document.querySelector('#header-content')) === null || _a === void 0 ? void 0 : _a.classList.add('active');
        mobileOpenBtn.setAttribute('data-role', 'close-popup');
        mobileOpenBtn.classList.add('active');
        document.body.classList.add('popup-opened');
        header.classList.add('bg-white');
    }
    function closeMobileMenu() {
        var _a;
        (_a = document.querySelector('#header-content')) === null || _a === void 0 ? void 0 : _a.classList.remove('active');
        mobileOpenBtn.setAttribute('data-role', 'open-popup');
        mobileOpenBtn.classList.remove('active');
        document.body.classList.remove('popup-opened');
        header.classList.remove('bg-white');
    }
    mobileOpenBtn.addEventListener('click', () => {
        if (mobileOpenBtn.getAttribute('data-role') === 'open-popup') {
            openMobileMenu();
        }
        else {
            closeMobileMenu();
        }
    });
    if (siteHeaderCTA) {
        siteHeaderCTA.addEventListener('click', () => {
            var _a;
            if ((_a = document.querySelector('#header-content')) === null || _a === void 0 ? void 0 : _a.classList.contains('active')) {
                closeMobileMenu();
            }
        });
    }
    mobileMenuLinks.forEach(link => {
        link.addEventListener('click', () => {
            closeMobileMenu();
        });
    });
    document.querySelectorAll('.swiper__nav, [name="acceptance"]').forEach((button) => {
        if (button instanceof HTMLElement) {
            button.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    button.click();
                }
            });
        }
    });
    window.document.addEventListener('scroll', () => {
        const operationType = header && Math.floor(window.scrollY) > 0 ? 'add' : 'remove';
        header.classList[operationType]('scroll-header');
        checkInView();
    });
    if (window.location.hash) {
        window.location.replace(window.location.origin + window.location.pathname);
    }
    window.addEventListener('resize', setRealViewportHeight);
    {
        const operationType = header && Math.floor(window.scrollY) > 0 ? 'add' : 'remove';
        header.classList[operationType]('scroll-header');
        checkInView();
    }
}
window.document.addEventListener('DOMContentLoaded', ready);
